document.addEventListener("DOMContentLoaded", function () {
  const h1 = document.querySelector("h1");
  if (!h1) return;

  const text = h1.innerHTML;
  const keyword = "REALLY AWESOME";

  if (text.includes(keyword)) {
    const parts = text.split(keyword);
    const afterText = parts[1]; // text after AWESOME

    const newHTML = `
      ${parts[0]}${keyword} 
      <span class="htag-cstm-cls" style="font-family: 'Optika-Bold Font' !important;">
        <img src="https://cdn.shopify.com/s/files/1/0637/1246/0867/files/RAE_HOMEPAGE-07.png?v=1762144642" style="vertical-align: middle; height:80px; width:80px;" />
        ${afterText}
      </span>
    `;

    h1.innerHTML = newHTML.trim();
  }
});
